var searchInput = document.querySelector('.header-main-search__input');
var xsSearchInput = document.getElementById('xs-search');
var searchButton = document.querySelector('.header-main-search__submit');
var inputToggle = document.querySelector('.input-toggle');
var searchTimeout = null;
var searchUrl = '/search?q=';

if (searchInput && xsSearchInput) {
    bindSearch(searchInput);
    bindSearch(xsSearchInput);

    window.addEventListener('resize', onOpenedSearchResults);
}

if (inputToggle) {
    inputToggle.addEventListener('click', function() {
        this.classList.add('is-hidden');
        searchInput.classList.add('is-clicked');
        searchButton.classList.add('is-visible');
    });
}

window.addEventListener('click', function(e) {
    var element = e.target;
    var inputToggleIcon = inputToggle.children[0];

    if (
        element !== inputToggleIcon &&
        element !== inputToggle &&
        element !== searchInput &&
        element !== searchButton
    ) {
        inputToggle.classList.remove('is-hidden');
        searchInput.classList.remove('is-clicked');
        searchButton.classList.remove('is-visible');
    };
});

var request = new XMLHttpRequest();

request.onreadystatechange = function() {
    if (request.readyState === 4) {
        if (request.status === 200) {
            var response = JSON.parse(request.responseText);
            if (response.results) {
                showSearchResults(response);
            }
        } else {
            // TODO: Show error ?
            // console.log('An error occurred during your request: ' +  request.status + ' ' + request.statusText);
        }
    }
};

function bindSearch(element) {
    element.onkeyup = function() {
        if (element.value.length >= 3) {
            clearTimeout(searchTimeout);

            searchTimeout = setTimeout(function () {
                request.open('Get', searchUrl + element.value);
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                request.send();
            }, 500);
        }
    };
}

function showSearchResults(response) {
    var prototypes = [];
    var maxResults = (response.results.length > 5 ? 5 : response.results.length);
    var searchResultsBlock = getSearchResultsBlock();

    // no products found
    if (response.results.length === 0 && searchResultsBlock) {
        var noResultsPrototype = searchInput.getAttribute('data-no-results-prototype');

        noResultsPrototype = noResultsPrototype.replace(/__url__/g, 'javascript:');
        searchResultsBlock.innerHTML = noResultsPrototype;
        searchResultsBlock.style.display = 'block';

        document.addEventListener('click', onClickOutsideSearchResults);

        return;
    }

    // prepare products html
    for (var i = 0; i < maxResults; i++) {
        var productUrl = getProductUrl(response.results[i]);
        var prototype = searchInput.getAttribute('data-result-prototype');

        prototype = prototype.replace(/__url__/g, productUrl);
        prototype = prototype.replace(/__name__/g, response.results[i].name);
        prototype = prototype.replace(/__code__/g, response.results[i].code);

        prototypes[i] = prototype;
    }

    // add products to search results
    if (searchResultsBlock) {
        searchResultsBlock.innerHTML = '';

        for (var j = 0; j < prototypes.length; j++) {
            searchResultsBlock.innerHTML += prototypes[j];
        }

        if (response.results.length > 5) {
            var allResultsPrototype = searchInput.getAttribute('data-all-results-prototype');

            allResultsPrototype = allResultsPrototype.replace(/__url__/g, searchUrl + response.searchTerm);
            searchResultsBlock.innerHTML += allResultsPrototype;
        }

        searchResultsBlock.style.display = 'block';
    }

    document.addEventListener('click', onClickOutsideSearchResults);
}

function onClickOutsideSearchResults(event) {
    var searchResultsBlock = getSearchResultsBlock();

    if (searchResultsBlock) {
        var isClickInSearchResults= searchResultsBlock.contains(event.target);

        if (!isClickInSearchResults) {
            document.removeEventListener('click', onClickOutsideSearchResults);
            searchResultsBlock.style.display = 'none';
        }
    }
}

function onOpenedSearchResults() {
    var searchResultsBlock = getSearchResultsBlock();

    if (searchResultsBlock) {
        document.removeEventListener('click', onClickOutsideSearchResults);
        searchResultsBlock.style.display = 'none';
    }
}

function getSearchResultsBlock() {
    var searchResultsClass = getSearchResultsClass();

    return document.querySelector(searchResultsClass);
}

function getSearchResultsClass() {
    var searchResultsClass = '.header-search-results--default';

    if (isMobileSizeXs() == true) {
        searchResultsClass = '.header-search-results--mobile';
    }

    return searchResultsClass;
}

function isMobileSizeXs() {
    return window.matchMedia('(max-width: 768px)').matches;
}

function getProductUrl(product) {
    var getUrl = window.location;
    var baseUrl = getUrl .protocol + '//' + getUrl.host + '/';

    return baseUrl + product.locale + '/' + product.slug;
}

